module.exports = __webpack_public_path__ + "static/media/red_close.6f55468f.svg";